import { Role, ADMIN_PERMISSIONS, Permissions } from "../../../types/permissions";

// Gecici ornek rol listesi (yetki matrisiyle). Backend getRoles() gercek veri
// dondurunce ref/ad eslestirilir; uye sayisi gibi turetilmis alanlar mock kalir.
export interface RoleRow extends Role {
    userCount: number;
}

const MANAGER_PERMS: Permissions = {
    dashboard: { view: true },
    tickets: { view: true, create: true, edit: true, delete: true },
    customers: { view: true, create: true, edit: true, delete: false },
    users: { view: true, create: true, edit: true, delete: false },
    vendors: { view: true, create: false, edit: true, delete: false },
    products: { view: true, create: false, edit: false, delete: false },
    roles: { view: true, create: false, edit: false, delete: false },
    settings: { view: true, edit: false },
    reports: { view: true },
};

const AGENT_PERMS: Permissions = {
    dashboard: { view: true },
    tickets: { view: true, create: true, edit: true, delete: false },
    customers: { view: true, create: false, edit: false, delete: false },
    vendors: { view: true, create: false, edit: false, delete: false },
    products: { view: true, create: false, edit: false, delete: false },
    reports: { view: true },
};

const VENDOR_ADMIN_PERMS: Permissions = {
    dashboard: { view: true },
    tickets: { view: true, create: true, edit: true, delete: false },
    users: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: false, edit: true, delete: false },
    products: { view: true, create: false, edit: false, delete: false },
};

const VENDOR_USER_PERMS: Permissions = {
    dashboard: { view: true },
    tickets: { view: true, create: true, edit: false, delete: false },
    products: { view: true },
};

export const MOCK_ROLES: RoleRow[] = [
    { ref: 1, name: "admin", display_name: "Yönetici (Admin)", description: "Tüm modüllere tam yetki", permissions: ADMIN_PERMISSIONS, is_active: true, sort_order: 1, created_at: "2025-01-10", userCount: 3 },
    { ref: 2, name: "manager", display_name: "Müdür (Manager)", description: "Yönetim ve raporlama, sınırlı silme", permissions: MANAGER_PERMS, is_active: true, sort_order: 2, created_at: "2025-01-10", userCount: 5 },
    { ref: 3, name: "agent", display_name: "Destek Temsilcisi", description: "Ticket yönetimi ve müşteri görüntüleme", permissions: AGENT_PERMS, is_active: true, sort_order: 3, created_at: "2025-01-12", userCount: 12 },
    { ref: 4, name: "vendor_admin", display_name: "Vendor Admin", description: "Bayi kullanıcı ve ticket yönetimi", permissions: VENDOR_ADMIN_PERMS, is_active: true, sort_order: 4, created_at: "2025-02-01", userCount: 18 },
    { ref: 5, name: "vendor_user", display_name: "Vendor User", description: "Ticket açma ve takip", permissions: VENDOR_USER_PERMS, is_active: true, sort_order: 5, created_at: "2025-02-01", userCount: 64 },
];

export function resolveRole(ref: number | string | undefined, list: RoleRow[]): RoleRow | null {
    if (ref == null || ref === "") return null;
    const pool = list.length ? list : MOCK_ROLES;
    return pool.find(r => String(r.ref) === String(ref)) ?? null;
}
